export default{
    // url:"/jeecg-boot", https://api.coolingmall.com
	url:"https://api.coolingmall.com/jeecg-boot"
}
